import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faThumbsUp, faTag, faHeadphonesSimple, faDollarSign, faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { FormattedMessage } from 'react-intl';

import Price from 'Components/Utility/Price/Price';
import Saving from 'Components/Utility/Price/Saving';

function BundleAudioPoints({
  price,
  downloadTypes,
  fullPrice,
  discountPercentOverride,
  giveaway,
  maxPrice,
  validDrm,
}) {
  return (
    <div className="BundlePoints BundlePoints--audio">
      <div className="BundlePoints__points container">
        <div className="BundlePoints__point">
          <div className="BundlePoints__dollarIcon BundlePoints__icon">
            <FontAwesomeIcon icon={faDollarSign} />
          </div>
          <div className="BundlePoints__pointText">
            <FormattedMessage
              id="audio-bar.worth_of_audio"
              defaultMessage="Get {price} worth of audio files"
              values={{
                price: <Price price={maxPrice} />,
              }}
            />
          </div>
        </div>

        {!isEmpty(downloadTypes) &&
          <div className="BundlePoints__point">
            <div className="BundlePoints__gameIcon BundlePoints__icon">
              <FontAwesomeIcon icon={faHeadphonesSimple} />
            </div>
            <div className="BundlePoints__pointText">
              {downloadTypes.length > 1 &&
                <FormattedMessage
                  id="audio-bar.audio-delivery-multi"
                  defaultMessage="Multi-format DRM-Free downloads"
                />
              }
              {downloadTypes.length === 1 &&
                <FormattedMessage
                  id="audio-bar.audio-delivery"
                  defaultMessage="DRM Free downloads"
                />
              }
            </div>
          </div>
        }

        {isEmpty(downloadTypes) && !giveaway &&
          <div className="BundlePoints__point">
            <div className="BundlePoints__gameIcon BundlePoints__icon">
              <FontAwesomeIcon icon={faThumbsUp} />
            </div>
            <div className="BundlePoints__pointText">
              <FormattedMessage
                id="audio-bar.audio_saving"
                defaultMessage="Save {saving}"
                values={{
                  saving: <Saving
                    price={price}
                    type="bundle"
                    fullPrice={fullPrice}
                    discountPercentOverride={discountPercentOverride}
                    showMinus={false}
                  />,
                }}
              />
            </div>
          </div>
        }

        {isEmpty(downloadTypes) && giveaway &&
          <div className="BundlePoints__point">
            <div className="BundlePoints__gameIcon BundlePoints__icon">
              <FontAwesomeIcon icon={faTag} />
            </div>
            <div className="BundlePoints__pointText">
              <FormattedMessage
                id="audio-bar.audio_saving"
                defaultMessage="Save {saving}"
                values={{
                  saving: <Saving
                    price={price}
                    type="bundle"
                    fullPrice={fullPrice}
                    discountPercentOverride={discountPercentOverride}
                    showMinus={false}
                  />,
                }}
              />
            </div>
          </div>
        }

        {isEmpty(validDrm) &&
          <div className="BundlePoints__point">
            <div className="BundlePoints__gameIcon BundlePoints__icon">
              <FontAwesomeIcon icon={faCircleCheck} />
            </div>
            <div className="BundlePoints__pointText">
              <FormattedMessage
                id="audio-bar.point.redeem.keys"
                defaultMessage="Key Redemption"
              />
            </div>
          </div>
        }
      </div>
    </div>
  );
}

BundleAudioPoints.propTypes = {
  price: PropTypes.shape({}),
  fullPrice: PropTypes.shape({}),
  maxPrice: PropTypes.shape({}),
  discountPercentOverride: PropTypes.number,
  downloadTypes: PropTypes.arrayOf(PropTypes.shape({})),
  giveaway: PropTypes.bool,
  validDrm: PropTypes.arrayOf(PropTypes.string),
};

BundleAudioPoints.defaultProps = {
  price: {},
  fullPrice: {},
  maxPrice: {},
  downloadTypes: [],
  discountPercentOverride: 0,
  giveaway: false,
  validDrm: [],
};

const mapStateToProps = ({
  siteTheme,
}) => ({
  siteTheme,
});

export default connect(mapStateToProps)(BundleAudioPoints);
